export default __webpack_public_path__ + "static/media/argent-logo.3cb8a1f6.png";